import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";

const PrivacyPolicy = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, [lenisRef]);
  return (
    <>
      <title>Privacy Policy | Citrus Diagnostic Center ,Crystal River</title>
      <meta
        name="description"
        content="Review the Privacy Policy of Citrus Diagnostic Center, Crystal River, to learn how we safeguard your data and maintain confidentiality in all imaging services."
      />

      <div className="flex justify-center items-center pt-48 lg:pt-[14.0625rem]">
        <div className="w-4/5  flex flex-col items-center  pb-8 lg:pb-16">
          <h1
            
            className="text-[#d78558] font-robout lg:text-6xl md:text-5xl text-4xl lg:pb-20 capitalize text-center leading-tight sm:leading-snug font-black"
          >
            Privacy Policy
          </h1>
          <div className="text-left">
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-8 text-left font-robout">
              Effective Date: September 7, 2025
            </p>
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-8 text-left font-robout">
              <span className="text-[#ffffff]">Citrus Diagnostic Center </span>{" "}
              (“Company,” “we,” “our,” or “us”) respects your privacy and is
              committed to protecting personal information. This Privacy Policy
              explains how we collect, use, and safeguard information when you
              visit our website.{" "}
            </p>
            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold  lg:ps-0 md:px-8 px-4 pt-10">
              1. Information We Collect
            </h2>
            <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white py-6">
              We may collect:
            </h3>
            <ul className="xl:text-[1.33rem] list-disc md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-8  text-left font-robout">
              <li>
                Information you submit through forms (e.g., name, phone number,
                email).
              </li>
              <li>
                Scheduling or billing requests submitted through our website or
                patient portal.
              </li>
              <li>
                Non-identifiable technical information (IP address, browser
                type, device information, cookies).
              </li>
            </ul>

            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold  lg:ps-0 md:px-8 px-4 pt-10">
              2. How We Use Information
            </h2>
            <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white py-6">
              We may use your information to:
            </h3>
            <ul className="xl:text-[1.33rem] list-disc md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-4  text-left font-robout">
              <li>Respond to appointment requests or inquiries.</li>
              <li>Provide customer support and patient services.</li>
              <li>Improve website performance and user experience.</li>
              <li>Comply with legal and regulatory requirements.</li>
            </ul>

            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold  lg:ps-0 md:px-8 px-4 py-10">
              3. HIPAA Notice
            </h2>
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              If you are a patient of Citrus Diagnostic Center, please refer to
              our HIPAA Notice of Privacy Practices (available in-office and
              online) for details about how we use and protect your protected
              health information (PHI)
            </p>

            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 pt-10">
              4. Sharing of Information
            </h2>
            <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white py-6">
              We do not sell or rent personal information. We may share
              information with:
            </h3>
            <ul className="xl:text-[1.33rem] list-disc md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-4  text-left font-robout">
              <li>
                Service providers (IT support, billing, scheduling software) who
                are bound by confidentiality agreements.
              </li>
              <li>Regulators or legal authorities as required by law.</li>
            </ul>

            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-5">
              5. Cookies and Analytics
            </h2>
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We may use cookies and analytics tools to track website usage
              trends. This helps us improve site performance and user
              experience. You can disable cookies in your browser settings.
            </p>
            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
              6. Security
            </h2>
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-8  text-left font-robout">
              We use reasonable safeguards to protect personal information.
              However, no website or internet transmission is 100% secure.
            </p>
            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 pb-4">
              7. Your Rights
            </h2>
            <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white py-6">
              You may request access, corrections, or deletion of your personal
              information by contacting us at:
            </h3>
            <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-8  text-left font-robout">
              <li>
                <span className="text-[#d78558]">Phone : </span>{" "}
                <a href="tel:3527959200"> (352) 450-8062</a>
              </li>
              <li>
                <span className="text-[#d78558]">Email : </span>{" "}
                <a href="mailto:info@citrusdiagnosticcenter.com">
                  info@citrusdiagnosticcenter.com
                </a>
              </li>
            </ul>
            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 pb-4">
              8. Children’s Privacy
            </h2>
            <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white pt-4 pb-10">
              Our website is not directed to children under 13, and we do not
              knowingly collect information from them.
            </h3>
            <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 pb-4">
              9. Changes to This Policy
            </h2>
            <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We may update this Privacy Policy periodically. Updates will be
              posted here with a new effective date
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
